/**
 * @name useProdutoContext
 * @author Keven Adan Bezerra | kevenadanb
 * @description Hook para usar o contexto de produtos
 * @returns {IProdutoContext} - Contexto de produtos
 * @package src/contexts/ProdutoContext/useProdutoContext.tsx
 */

import { useContext } from "react";
import { ProdutoContext } from "./ProdutoContext";

/**
 * Hook para acessar o contexto de produtos
 */
export const useProdutoContext = () => {
  const context = useContext(ProdutoContext);

  if (!context) {
    throw new Error(
      "useProdutoContext deve ser usado dentro de um ProdutoProvider",
    );
  }

  return context;
};

export default useProdutoContext;
